import { useState, useEffect } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { useNavigate } from 'react-router-dom';
import { AppWatch } from '@wajeez-web/core/api-base';
import { HiOutlineIdentification } from 'react-icons/hi';
import { AiOutlineMail } from 'react-icons/ai';
import { RxEyeOpen, RxEyeClosed } from 'react-icons/rx';
import { SiContactlesspayment } from 'react-icons/si';
import { FcExpired } from 'react-icons/fc';
import { TbCalendarTime } from 'react-icons/tb';
import { AiOutlineAccountBook } from 'react-icons/ai';
import { GiDuration } from 'react-icons/gi';
import { BiCategory } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  WajeezAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';

const PremiumUsersAnalysisPage = () => {
  const [tablePagenation, setTablePagenation] = useState({
    page: 1,
    pageSize: 50,
  });
  const dispatch = useAppwatchDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { premiumCustomers, premiumCustomersStatus } = useAppwatchSelector(
    (c) => c.wajeezAnalysis
  );
  const columns: ColumnsType<AppWatch.GetPremiumClientsResponse> = [
    { title: '#', dataIndex: 'Id', key: 'Id', width: '300px' },
    { title: t('tables.columnTitles.Email'), dataIndex: 'Email', key: 'Email' },

    {
      title: t('tables.columnTitles.LastSeen'),
      dataIndex: 'LastSeen',
      key: 'LastSeen',
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      render: (record) => (
        <a
          className="text-primary"
          href={`/wajeez-customers/${record.Id}/analytics`}
          target="_blank"
        >
          عرض
        </a>
      ),
    },
  ];
  useEffect(() => {
    dispatch(WajeezAnalysisActions.getPremiumCustomersAsync(tablePagenation));
  }, [tablePagenation]);

  return (
    <PageLayoutsContainer
      title={`Premium Users Analysis`}
      withoutRightPadding={false}
    >
      <div className="space-y-6">
        <Table
          loading={premiumCustomersStatus === 'loading'}
          pagination={{
            total: premiumCustomers?.totalCount,
            onChange(page, pageSize) {
              setTablePagenation({ page, pageSize });
            },
            pageSizeOptions: ['50', '100', '200'],
            defaultPageSize: 50,
          }}
          columns={columns}
          expandable={{
            expandedRowRender: (record) => (
              <div className=" grid grid-cols-2 gap-4">
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <HiOutlineIdentification className="h-5 w-5 text-primary" />
                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.User ID" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">{record.Id}</div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <AiOutlineMail className="h-5 w-5 text-primary" />
                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.Email" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">{record.Email}</div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <RxEyeOpen className="h-5 w-5 text-primary" />
                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.First Seen" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">{record.FirstSeen}</div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <RxEyeClosed className="h-5 w-5 text-primary" />
                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.Last Seen" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">{record.LastSeen}</div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <SiContactlesspayment className="h-5 w-5 text-primary" />
                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.Subscription Date" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">{record.SubscriptionDate}</div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <FcExpired className="h-5 w-5 text-primary" />

                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.Expiration Date" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">{record.ExpirationDate}</div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <TbCalendarTime className="h-5 w-5 text-primary" />

                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.Subscription Period" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">
                    {record.SubscriptionPeriod}
                  </div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <AiOutlineAccountBook className="h-5 w-5 text-primary" />
                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.Count" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">{record.Count}</div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <GiDuration className="h-5 w-5 text-primary" />

                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.Session Duration In Hours" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">
                    {record.SessionDurationInHours}
                  </div>
                </div>
                <div className=" col-span-1 ">
                  <div className="flex flex-row space-s-2 items-center">
                    <BiCategory className="h-5 w-5 text-primary" />

                    <div className="font-bold text-lg">
                      {
                        <ReturnTranslatedText text="tables.columnTitles.Followed Categories" />
                      }
                    </div>
                  </div>
                  <div className="text-sm px-7">
                    {record.FollowedCategories}
                  </div>
                </div>
              </div>
            ),
          }}
          dataSource={premiumCustomers?.data?.map((c) => ({ ...c, key: c.Id }))}
        />
      </div>
    </PageLayoutsContainer>
  );
};

export default PremiumUsersAnalysisPage;
